import { CONTACT_TYPE } from './service-provider/interface';

export const CONTACT_TYPE_STRING: Partial<Record<CONTACT_TYPE, string>> = {
  [CONTACT_TYPE.MOBILE]: 'Номер телефона',
  [CONTACT_TYPE.EMAIL]: 'Почта',
};

export type ContactType = CONTACT_TYPE.MOBILE | CONTACT_TYPE.EMAIL;

export interface UserContactFormType {
  type: ContactType;
  phoneValue: string;
  emailValue: string;
}

export const UserContactFromInitialValues: UserContactFormType = {
  type: CONTACT_TYPE.MOBILE,
  emailValue: '',
  phoneValue: '',
};

export enum CONTACT_INPUT_MODES {
  PHONE = 'phone',
  EMAIL = 'email',
}
